module.exports = __webpack_public_path__ + "fonts/Lato-300-latin2.716309a.woff2";